import { useUserContext } from 'providers/UserProvider';
import { authApi } from 'api';
import { useNavigate } from 'react-router-dom';

const useHomeRedirect = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const navigate = useNavigate();

  const getHomePath = () => {
    const tenant = selectedTenant?.domains?.[0]?.domain;
    const warehouse = selectedWarehouse?.domain;

    if (tenant && warehouse) {
      return `/${tenant}/${warehouse}/`;
    }
    return null;
  };

  const logoutAndRedirect = async () => {
    try {
      await authApi.logout();
      navigate('/auth/login');
    } catch (error) {
      console.error('Failed to logout:', error);
      navigate('/auth/login');
    }
  };

  return { getHomePath, logoutAndRedirect };
};

export default useHomeRedirect;
